// extracted by mini-css-extract-plugin
export default {"societyPic":"SocietyPicture_societyPic__tJzPP","large":"SocietyPicture_large__C8Dfo","medium":"SocietyPicture_medium__foDyl","normal":"SocietyPicture_normal__gEy2e"};